import { BrowserRouter } from 'react-router-dom'
import { ChatBot } from '@/components/ChatBot'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { CookieConsent } from '@/components/CookieConsent'
import { LanguageRouter } from '@/components/LanguageRouter'
import { ScrollToTop } from '@/components/ScrollToTop'

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CookieConsentProvider>
        <ChatBotProvider>
          <LanguageRouter />
          <ChatBot />
          <CookieConsent />
        </ChatBotProvider>
      </CookieConsentProvider>
    </BrowserRouter>
  )
}
